import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';
import { LinkReportItem } from '@redlink/components/muscles';

export const ReportTopList = memo(({ data = [] }) => {
  const { styles } = useStyle();

  return (
    <View style={styles.bodyContainer}>
      {data
        .map((item) => <LinkReportItem {...item} />)
        .reduce((prev, current) => [prev, <Space size={8} />, current], [])}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  bodyContainer: {},
}));
